import { Dispatch, ReactNode, SetStateAction } from 'react';
import { Icon, Icons, Typography, TypographyType } from '../../components';
import { IntegrationConnectionStatus, IntegrationService, SemanticColor, TextColor } from '../../types';
import DisconnectButton from './DisconnectButton';

export const SECRET_KEY_HIDDEN_CHARS_NUMBER = 42;

interface IntegrationMethod {
  id: string;
  title: string;
  description: ReactNode;
  content: ReactNode;
}

interface IntegrationItemLayoutProps {
  connectionStatus: IntegrationConnectionStatus;
  service: IntegrationService;
  methods: IntegrationMethod[];
  setConnectionStatus: Dispatch<SetStateAction<IntegrationConnectionStatus>>;
}

const IntegrationItemLayout = ({
  connectionStatus,
  service,
  methods,
  setConnectionStatus,
}: IntegrationItemLayoutProps) => {
  const isConnected = connectionStatus === IntegrationConnectionStatus.CONNECTED;

  return (
    <div className="flex flex-col gap-4">
      {methods.map(({ id, title, description, content }) => (
        <div className="flex flex-col gap-4" key={id}>
          <div className="flex flex-col gap-1">
            <Typography type={TypographyType.H4}>{title}</Typography>
            <Typography type={TypographyType.BASE} color={TextColor.SECONDARY}>
              {description}
            </Typography>
          </div>
          {content}
        </div>
      ))}
      {connectionStatus !== IntegrationConnectionStatus.DISCONNECTED && (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Typography type={TypographyType.BASE}>
              Status: <span className="font-semibold">{connectionStatus}</span>
            </Typography>
            <Icons
              icon={isConnected ? Icon.CHECK : Icon.CLOSE}
              color={isConnected ? SemanticColor.PRIMARY : TextColor.DESTRUCTIVE}
            />
          </div>
          {isConnected && <DisconnectButton service={service} setConnectionStatus={setConnectionStatus} />}
        </div>
      )}
    </div>
  );
};

export default IntegrationItemLayout;
